import React from 'react';

const LockToggle = ({ value, onChange, darkMode }) => {
  return (
    <div className="flex space-x-2 mb-4" role="radiogroup" aria-label="Наличие замка">
      <button
        onClick={() => onChange("Да")}
        className={`px-4 py-2 rounded-full text-sm ${value === "Да"
          ? 'bg-green-500 text-white'
          : (darkMode ? 'bg-gray-700 text-white' : 'bg-gray-200 text-gray-800')
          }`}
        role="radio"
        aria-checked={value === "Да"}
      >
        Да
      </button>
      <button
        onClick={() => onChange("Нет")}
        className={`px-4 py-2 rounded-full text-sm ${value === "Нет"
          ? 'bg-red-500 text-white'
          : (darkMode ? 'bg-gray-700 text-white' : 'bg-gray-200 text-gray-800')
          }`}
        role="radio"
        aria-checked={value === "Нет"}
      >
        Нет
      </button>
    </div>
  );
};

export default LockToggle;